// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_f6n","cls2":"utils-cls2_P7d utils-cls1_f6n"};